import { defineComponent as n, openBlock as t, createBlock as l, unref as a, mergeProps as c, withCtx as i, createElementVNode as p } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconArrowDownInCircleFilled",
  __name: "IconArrowDownInCircleFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const r = o;
    return (s, e) => (t(), l(a(m), c(r, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        p("path", { d: "M12 21.752c-5.385 0-9.75-4.366-9.75-9.75S6.615 2.25 12 2.25s9.75 4.366 9.75 9.75-4.365 9.75-9.75 9.75m-.884-4.816a1.25 1.25 0 0 0 1.768 0l3.232-3.232a.75.75 0 0 0-1.06-1.061l-2.306 2.305v-7.19a.75.75 0 1 0-1.5 0v7.19l-2.306-2.305a.75.75 0 0 0-1.06 1.06l3.232 3.233" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
